var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1317,
    height: 431,
    viewBox: "0 0 1317 431",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7695_347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 375.861C99.3043 419.251 214.78 434.575 312.497 390.595C319.343 387.676 326.104 383.944 332.697 380.548C391.417 345.185 447.584 305.752 508.549 273.251C576.218 236.906 651.716 212.91 728.868 210.44C735.489 210.187 745.421 209.486 751.958 209.738L775.047 210.103C788.402 210.159 807.535 212.236 821.058 213.022C880.788 218.607 943.099 226.016 1002.94 224.725C1046.9 223.827 1095.27 216.614 1126.02 182.262C1149.59 157.283 1158.28 122.509 1175.23 93.2644C1188.25 69.8573 1204.52 47.3204 1226.32 31.3227C1251.23 12.7431 1282.06 5.72658 1312.03 0.394043C1282.6 6.84922 1252.19 14.82 1228.11 33.7084C1204.24 52.3442 1187.69 78.8946 1174.72 105.894C1168.02 119.197 1162.46 134.241 1156.29 147.74C1118.89 232.584 1038.46 236.289 957.183 234.099C903.794 232.444 850.572 226.044 797.379 222.256C782.005 220.796 761.917 220.993 746.403 220.74C736.05 221.245 722.836 221.863 712.484 222.396C708.359 222.845 688.805 225.09 684.4 225.567C624.362 233.65 567.072 254.56 513.515 282.654C459.676 310.972 408.728 344.623 356.657 376.169C330.649 392.672 301.752 405.021 271.901 412.711C182.236 435.136 85.6413 416.725 4.05611 375.833L4 375.861Z",
    fill: "url(#paint0_linear_7695_347)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7695_347",
    x: 0,
    y: 0.394043,
    width: 1316.03,
    height: 429.973,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7695_347"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7695_347",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7695_347",
    x1: 4,
    y1: 211.381,
    x2: 1312.03,
    y2: 211.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#1A76D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#1A76D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.6e90fff771c89d8914ea127e764cc9ec.svg";
export { ForwardRef as ReactComponent };